$(document).ready(function(){


    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (isIE11){
        $('#logo-bm').remove();
        $('.header .wrapper > a.first-load:first-child').append('<img src="/images/interface/logo_namsys.svg" alt="NamSys" class="header__logo">');
    }


    $('body').addClass('page-ready');

    $('.solution-picker.home .solution-picker-nav__item').click(function(){

        var targetSolutionSlug = $(this).attr('target-solution');
        activateSolutionPickerSolution(targetSolutionSlug)
    });

    activateSolutionPickerSolution('smart-safe-monitoring');

    function activateSolutionPickerSolution(targetSolutionSlug){
        $('.solution-picker.home .solution-picker-nav__item').removeClass('active');
        $('.solution-picker.home .solution-picker-nav__item[target-solution='+targetSolutionSlug+']').addClass('active');
        $('.solution-picker.home .solution-picker-selected').hide();
        $('.solution-picker.home .solution-picker-selected[solution-slug='+targetSolutionSlug+']').fadeIn().css('display', 'flex');
    }



    $('.solution-picker-dropdown .solution-picker-nav__item').hover(function(){
        var targetSolutionSlug = $(this).attr('target-solution');
        solutionPickerDropdownHover(targetSolutionSlug)
    }, function(){
        var targetSolutionSlug = $(this).attr('target-solution');
        solutionPickerDropdownHover(targetSolutionSlug)
    });



    $('.solution-picker-dropdown .solution-picker-selected').hover(function(){
        var targetSolutionSlug = $(this).attr('solution-slug');
        $('.solution-picker-nav__item[target-solution='+targetSolutionSlug+']').addClass('hover');

    }, function(){
        var targetSolutionSlug = $(this).attr('solution-slug');
       $('.solution-picker-nav__item[target-solution='+targetSolutionSlug+']').removeClass('hover');
    });

    var firstSolutionNavItem = $('.solution-picker-dropdown .solution-picker-nav__item.active');
    var firstSolutionSelected = $('.solution-picker-dropdown .solution-picker-selected.active');

    function solutionPickerDropdownHover(targetSolutionSlug){
       // $('.solution-picker-dropdown .solution-picker-nav__item').removeClass('active');
        //$('.solution-picker-dropdown .solution-picker-nav__item[target-solution='+targetSolutionSlug+']').addClass('active');
        //$('.solution-picker-dropdown .solution-picker-selected').hide();
        //$('.solution-picker-dropdown .solution-picker-selected[solution-slug='+targetSolutionSlug+']').show().css('display', 'flex');
        $('.solution-picker-dropdown .solution-picker-selected').removeClass('active');
        $('.solution-picker-dropdown .solution-picker-selected[solution-slug='+targetSolutionSlug+']').addClass('active');
    }



    $('.js-toggle-solutions-nav').hover(function(){
        $('.solution-picker-dropdown').addClass('visible');

    }, function(){
        $('.solution-picker-dropdown').removeClass('visible');
        // $('.solution-picker-dropdown .solution-picker-nav__item').removeClass('active');
        $('.solution-picker-dropdown .solution-picker-selected').removeClass('active');
        // setTimeout(function(){
        //     $('.solution-picker-dropdown .solution-picker-nav__item').removeClass('active');
        //     $('.solution-picker-dropdown .solution-picker-selected').removeClass('active');
        //     firstSolutionNavItem.addClass('active');
        //     firstSolutionSelected.addClass('active');
        //     }, 500);
    });


    // $('.featured-case-studies-slider .cycle-slide.cycle-slide-active').next().find('.featured-case-study').click(function(){
    //     console.log('test');
    //
    //     // var slideIndex = $(this).attr('slide-num');
    //     //
    //     // console.log(slideIndex);
    //     $('.featured-case-studies-slider').cycle('next');
    //
    // });
    // $('.featured-case-studies-slider .cycle-slide.cycle-slide-active').prev().find('.featured-case-study').click(function(){
    //     $('.featured-case-studies-slider').cycle('prev');
    // });


$('.js-open-mobile-nav').click(function(){
    if ($('body').hasClass('mobile-nav-is-open')){
    closeMobileNav();
    } else {
    openMobileNav();
    }
});


    function openMobileNav(){
        $('body').addClass('mobile-nav-is-open');
    }

    function closeMobileNav(){
        $('body').removeClass('mobile-nav-is-open');
    }


    const animateRows = document.querySelectorAll('.js-view-check');




     var scrollThrottleTimeout;
            $(window).bind(
                'scroll',
                function()
                {
                    if (!scrollThrottleTimeout) {
                        scrollThrottleTimeout = setTimeout(
                            function()
                            {
                                //  console.log('test');
                                onPageScroll();
                                scrollThrottleTimeout = null;
                            },
                            100
                        );
                    }
                }
            );


            function onPageScroll(){
                // console.log("Scrolled");
                if ($(window).scrollTop() >= 30) {
                    $('.header').addClass('fixed');
                } else {
                    $('.header').removeClass('fixed');
                }
            }

onPageScroll();


                $('.faq-post-block__question[aria-controls]').click(function(){
                    // $(this).toggleClass('open-accordion');

                    var ariaControlsId = $(this).attr('aria-controls');
                    // $('.accordion-block__main-content[id="' + ariaControlsId + '"]').slideToggle();

                    var ariaExpanded = $(this).attr('aria-expanded');

                    if (ariaExpanded == 'false'){
                        $(this).attr("aria-expanded","true");
                    } else {
                        $(this).attr("aria-expanded","false");
                    }

                });



    $(".js-scroll-to").click(function (){
    	var scrollTarget = $(this).attr('scroll-to');
        $('html, body').animate({
            scrollTop: $('.'+scrollTarget).offset().top - 100
        }, 800);
    });





});

